export const initialState = {
  id: null,
  text: "",
  icon: null,
  color: null,
  progress_at: [],
  child_ids: [],
  parent_ids: [],
  completed_at: null,
  created_at: null,
  // loading: true,
};

export const value = (state = initialState, action) => {
  if (action.type === "value/progress") {
    // If so, make a copy of `state`
    // console.log(state)
    return {
      ...state,
      updatedAt: new Date().toString(),
      progressAt: [...state.progressAt, action.timestamp],
    };
  } else if (action.type === "value/show") {
    // let value = await
    return {
      ...state,
      updatedAt: new Date().toString(),
      progressAt: [...state.progressAt, action.timestamp],
    };
  }
  // otherwise return the existing state unchanged
  return state;
};
